import { render, staticRenderFns } from "./FormDesignRender.vue?vue&type=template&id=61b47d07&scoped=true"
import script from "./FormDesignRender.vue?vue&type=script&lang=js"
export * from "./FormDesignRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b47d07",
  null
  
)

export default component.exports